import { render } from "./SaleList.vue?vue&type=template&id=356b6078&scoped=true"
import script from "./SaleList.vue?vue&type=script&lang=js"
export * from "./SaleList.vue?vue&type=script&lang=js"

import "./SaleList.vue?vue&type=style&index=0&id=356b6078&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356b6078"]])

export default __exports__